import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi'
import { z } from 'zod'
import { AssigneeTypeEnum, RequestStepTaskTypeEnum } from '@omnea-app/packages/universal/hasura/graphql'

extendZodWithOpenApi(z)

export const AssigneeSchema = z
  .object({
    id: z.string(),
    value: z.string(),
    name: z.string().optional(),
    email: z.string().optional(),
    type: z.nativeEnum(AssigneeTypeEnum),
  })
  .openapi('Assignee')

export type AssigneeEntity = z.infer<typeof AssigneeSchema>
export const RequestStepTaskSchema = z.object({
  id: z.string(),
  request_step_id: z.string(),
  request_form_id: z.string().optional().nullable(),
  type: z.nativeEnum(RequestStepTaskTypeEnum),
  completed_on: z.string().optional().nullable(),
  completed_by: z.string().optional().nullable(),
  organisation_id: z.string(),
  created_at: z.string(),
  config: z.any(),
})
